/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import { useTranslation } from "react-i18next";

const SaveOffersPopup = ({
  afterPopupCLose = () => {},
  pricingId = null,
  setPricingId = () => {},
  setShowAlert = () => {},
  setAlertMessage = () => {},
  setMessageType = () => {},
}) => {
  const token = localStorage.getItem("token"); // token
  const { t } = useTranslation(); //for translation
  const todayValue = new Date().toISOString().split("T")[0];

  const { id } = useParams();

  const [variant, setVariant] = useState("");
  const [price, setPrice] = useState("");
  const [discountedPrice, setDiscountedPrice] = useState("");
  const [unit, setUnit] = useState("");
  const [sku, setSku] = useState("");
  const [startDate, setStartDate] = useState(todayValue);
  const [endDate, setEndDate] = useState(todayValue);
  const [isActive, setisActive] = useState(false);

  const [isSaving, setIsSaving] = useState(false);

  /* hook for validation */
  const [errors, setErrors] = useState({});

  /* function to validate form */
  const validationHandler = () => {
    const newErrors = {};

    if (variant.trim() === "") {
      newErrors.name = t("Please enter a name for the variant.");
    }

    if (sku.trim() === "") {
      newErrors.sku = t("Please enter a sku for the variant.");
    }

    if (price.trim() === "") {
      newErrors.price = t("Please enter a price for the variant.");
    }

    if (discountedPrice.trim() === "") {
      newErrors.discountedPrice = t(
        "Please enter a discounted price for the variant."
      );
    }

    if (unit.trim() === "") {
      newErrors.unit = t("Please enter a unit for the variant.");
    }

    if (startDate === "") {
      newErrors.startDate = t("Please enter a start date for the variant.");
    }

    if (endDate === "") {
      newErrors.endDate = t("Please enter an end date for the variant.");
    }

    if (startDate !== "" && endDate !== "") {
      if (startDate > endDate) {
        newErrors.dateDiff = t("End date cannot be earlier than start date.");
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  //get details
  const getDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_PRODUCT_PRICING_DETAILS +
        `/${pricingId}` +
        `?token=${token}`;

      const response = await getData(requestUrl);

      console.log(response);

      if (response.status) {
        const data = response.data;

        setVariant(data.variant);
        setPrice(data.price);
        setDiscountedPrice(data.discountprice);
        setUnit(data.stock);
        setSku(data.sku);
        setStartDate(data.startdate);
        setEndDate(data.enddate);
        setisActive(data.isactive);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for create new tag
  const saveOfferHandler = async () => {
    if (!validationHandler()) {
      return;
    }
    setIsSaving(true);
    try {
      let sendingData = {
        productid: id,
        variant,
        price,
        discountprice: discountedPrice,
        stock: unit,
        sku,
        startdate: startDate,
        enddate: endDate,
        isactive: isActive,
      };

      let requestUrl = url.API_BASE_URL;

      let response = {};

      if (pricingId) {
        requestUrl =
          requestUrl +
          url.API_UPDATE_PRODUCT_PRICING +
          `/${pricingId}` +
          `?token=${token}`;

        response = await putData(requestUrl, sendingData);
      } else {
        requestUrl =
          requestUrl + url.API_ADD_PRODUCT_PRICING + `?token=${token}`;

        response = await postData(requestUrl, sendingData);
      }

      setIsSaving(false);
      console.log(response);

      if (response.status) {
        // close the modal of addLabel
        bootstrap.Offcanvas.getInstance(
          document.querySelector("#offcanvasSaveOffer")
        ).hide();
        resetHandler();
        setMessageType("success");
        setAlertMessage(response.message);
        setTimeout(() => {
          afterPopupCLose();
        }, 1500);
      }
    } catch (error) {
      console.log(error.message);
      setMessageType("error");
      setAlertMessage(error.message);
    }

    setShowAlert(true);
  };

  /* reset */
  const resetHandler = () => {
    setVariant("");
    setPrice("");
    setDiscountedPrice("");
    setUnit("");
    setSku("");
    setStartDate(todayValue);
    setEndDate(todayValue);
    setisActive(false);

    setPricingId(null);

    setErrors({});
  };

  useEffect(() => {
    if (pricingId) {
      getDetails();
    }
  }, [pricingId]);

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0 shadow-lg"
      tabIndex="-1"
      id="offcanvasSaveOffer"
      aria-labelledby="offcanvasSaveOfferLabel"
    >
      <div className="offcanvas-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              sell
            </span>{" "}
            {/* Using 'sell' icon for offers */}
          </div>
          <div>
            <h3
              className="offcanvas-title fw-bold text-white mb-0"
              id="offcanvasSaveOfferLabel"
            >
              {pricingId ? t("Edit Offer") : t("Create Offer")}
            </h3>
            <p className="text-white fs-sm mb-0">
              {pricingId
                ? t("Manage existing offer details")
                : t("Define a new offer")}
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>
      <div className="offcanvas-body p-4">
        {isSaving && (
          <div className="d-flex flex-column justify-content-center align-items-center position-absolute top-0 start-0 w-100 h-100 bg-white bg-opacity-75 z-index-1050">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">
                {t("Loading offer details...")}
              </span>
            </div>
            <p className="text-primary mt-3 fw-bold">
              {t("Loading offer details...")}
            </p>
          </div>
        )}
        <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm bg-light">
          <form
            onSubmit={(e) => e.preventDefault()}
            className="d-flex flex-column h-100"
          >
            <div className="fields-container flex-fill">
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="labelName"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Variant Name")}
                  <span className="text-danger fw-bold">*</span>
                </label>
                <input
                  type="text"
                  id="labelName"
                  className={`form-control fs-sm shadow-none ${
                    errors.name ? "is-invalid" : "border border-gray-300"
                  }`}
                  placeholder={t("e.g., 'Red T-Shirt, Large' or '500g Pack'")}
                  value={variant}
                  onChange={(e) => {
                    setVariant(e.target.value);
                    if (errors.name) {
                      setErrors((prev) => ({ ...prev, name: "" }));
                    }
                  }}
                />

                {errors.name && (
                  <div className="invalid-feedback d-block">{errors.name}</div>
                )}
              </div>

              {/* price */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="price"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Price")} <span className="text-danger fw-bold">*</span>
                </label>
                <input
                  min={1}
                  type="number"
                  className={`form-control fs-sm shadow-none ${
                    errors.price ? "is-invalid" : "border border-gray-300"
                  }`}
                  placeholder={t("e.g., 29.99")}
                  value={price}
                  onChange={(e) => {
                    setPrice(e.target.value);
                    if (errors.price) {
                      setErrors((prev) => ({ ...prev, price: "" }));
                    }
                  }}
                />

                {errors.price && (
                  <div className="invalid-feedback d-block">{errors.price}</div>
                )}
              </div>

              {/* discount price  */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="price"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Discount Price")}{" "}
                  <span className="text-danger fw-bold">*</span>
                </label>
                <input
                  type="number"
                  className={`form-control fs-sm shadow-none ${
                    errors.discountedPrice
                      ? "is-invalid"
                      : "border border-gray-300"
                  }`}
                  placeholder={t("e.g., 25.99")}
                  value={discountedPrice}
                  onChange={(e) => {
                    setDiscountedPrice(e.target.value);
                    if (errors.discountedPrice) {
                      setErrors((prev) => ({ ...prev, discountedPrice: "" }));
                    }
                  }}
                />

                {errors.discountedPrice && (
                  <div className="invalid-feedback d-block">
                    {errors.discountedPrice}
                  </div>
                )}
              </div>

              <div className="row  mb-4">
                <div className="col-6">
                  <div className="form-group p-3 border rounded-8 shadow-sm bg-white">
                    <label
                      htmlFor="date-range"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      {t("Unit")} <span className="text-danger fw-bold">*</span>
                    </label>
                    <input
                      min={1}
                      type="number"
                      id="slug"
                      className={`form-control fs-sm shadow-none ${
                        errors.unit ? "is-invalid" : "border border-gray-300"
                      }`}
                      placeholder={t("e.g., 100")}
                      value={unit}
                      onChange={(e) => {
                        setUnit(e.target.value);
                        if (errors.unit) {
                          setErrors((prev) => ({ ...prev, unit: "" }));
                        }
                      }}
                    />

                    {errors.unit && (
                      <div className="invalid-feedback d-block">
                        {errors.unit}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-6">
                  <div className="form-group p-3 border rounded-8 shadow-sm bg-white">
                    <label
                      htmlFor="date-range"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      {t("Sku")} <span className="text-danger fw-bold">*</span>
                    </label>
                    <input
                      type="text"
                      id="slug"
                      className={`form-control fs-sm shadow-none ${
                        errors.sku ? "is-invalid" : "border border-gray-300"
                      }`}
                      placeholder={t("e.g., 1234567890")}
                      value={sku}
                      onChange={(e) => {
                        setSku(e.target.value);
                        if (errors.sku) {
                          setErrors((prev) => ({ ...prev, sku: "" }));
                        }
                      }}
                    />

                    {errors.sku && (
                      <div className="invalid-feedback d-block">
                        {errors.sku}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="date-range"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Date Range")}{" "}
                  <span className="text-danger fw-bold">*</span>
                </label>
                <div className="d-flex gap-3">
                  <div className="w-50">
                    <input
                      type="date"
                      id="from-date"
                      className={`form-control fs-sm shadow-none ${
                        errors.startDate
                          ? "is-invalid"
                          : "border border-gray-300"
                      }`}
                      placeholder={t("From Date")}
                      value={startDate}
                      onChange={(e) => {
                        setStartDate(e.target.value);
                        if (errors.startDate) {
                          setErrors((prev) => ({ ...prev, startDate: "" }));
                        }
                        if (errors.dateDiff) {
                          setErrors((prev) => ({ ...prev, dateDiff: "" }));
                        }
                      }}
                    />
                    {errors.startDate && (
                      <div className="invalid-feedback d-block">
                        {errors.startDate}
                      </div>
                    )}
                  </div>
                  <div className="w-50">
                    <input
                      type="date"
                      id="to-date"
                      className={`form-control fs-sm shadow-none ${
                        errors.endDate ? "is-invalid" : "border border-gray-300"
                      }`}
                      placeholder={t("To Date")}
                      value={endDate}
                      onChange={(e) => {
                        setEndDate(e.target.value);
                        if (errors.endDate) {
                          setErrors((prev) => ({ ...prev, endDate: "" }));
                        }
                        if (errors.dateDiff) {
                          setErrors((prev) => ({ ...prev, dateDiff: "" }));
                        }
                      }}
                    />
                    {errors.endDate && (
                      <div className="invalid-feedback d-block">
                        {errors.endDate}
                      </div>
                    )}
                  </div>
                </div>

                {errors.dateDiff && (
                  <div className="invalid-feedback d-block">
                    {errors.dateDiff}
                  </div>
                )}
              </div>

              {/* is active */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <div className="form-check d-flex align-items-center gap-2 fs-sm p-0 m-0">
                  <input
                    className="form-check-input bg-transparent border-2 border-gray-600 shadow-none m-0"
                    type="checkbox"
                    role="switch"
                    checked={isActive}
                    onChange={(e) => {
                      setisActive(e.target.checked);
                    }}
                  />
                  <label
                    className="form-check-label fw-semibold text-dark"
                    htmlFor="private"
                  >
                    {t("Is Active")}
                  </label>
                </div>
              </div>
            </div>
            <div className="action d-flex justify-content-end pt-3 border-top mt-auto">
              <button
                onClick={saveOfferHandler}
                type="button"
                className="btn btn-primary d-flex align-items-center gap-2"
                disabled={isSaving ? true : false}
                style={{
                  cursor: isSaving ? "not-allowed" : "pointer",
                }}
              >
                {isSaving ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    {t("Saving...")}
                  </>
                ) : (
                  <>
                    <span className="material-symbols-outlined me-1">save</span>{" "}
                    {t("Save Offer")}
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SaveOffersPopup;
